import { UseFieldArrayRemove } from 'react-hook-form';

import { Widget } from '@kanda-libs/ks-component-ts';

import { INCOME_PROPS, INCOME_SELECT_PROPS } from './constants';
import useIncomeItem from './useIncomeItem';

import IncomeExpenseWrapper from '../Wrapper';

export interface IncomeItemProps {
  index: number;
  remove: UseFieldArrayRemove;
}

const IncomeItem: React.FunctionComponent<IncomeItemProps> = function ({
  index,
  remove,
}) {
  const { removeItem, selectValidation, amountValidation } = useIncomeItem(
    index,
    remove,
  );

  return (
    <IncomeExpenseWrapper remove={removeItem}>
      <div className="flex flex-row gap-x-3 md:gap-x-4">
        <Widget.CreditFinanceDetailsIncomesIncomeTypeArraySelect
          index={index}
          {...INCOME_SELECT_PROPS}
          validation={selectValidation}
        />
        <Widget.CreditFinanceDetailsIncomesMonthlyAmountAmountArrayInput
          index={index}
          {...INCOME_PROPS}
          validation={amountValidation}
        />
      </div>
    </IncomeExpenseWrapper>
  );
};

export default IncomeItem;
